// Module
var code = "<div class=\"col-md-12\"> <h1>Need Help?</h1> <p>Best way to get help: email us at: </p> <h3 class=\"text-center\"> info@countryglen.org </h3> </div> ";
// Exports
module.exports = code;